export namespace TResponse {
  // eslint 响应的code码
  export const SUCCESS_CODE = 200; // 响应成功CODE值
  export const CODE_0 = 0; // 交互错误CODE码
  export const CODE_201 = 201; // 201:已在当前房间内通话
  export const CODE_401 = 401; // 401: 用户PC端登录 登录互斥
  export const CODE_444 = 444; // 444:在其他房间内通话 或 单人通话已在通话中
  export const CODE_445 = 445; // 445:已在其他端通话
  export const CODE_500 = 500; // 未知错误
  export const CODE_501 = 501; // 501: 创建房间异常
  export const CODE_502 = 502; // 502: 获取参会人状态异常
  export const CODE_503 = 503; // 503: 保存房间失败
  export const CODE_504 = 504; // 504: 保存参会人信息失败
  export const CODE_505 = 505; // 505: 保存参会人状态失败
  export const CODE_506 = 506; // 506: 推送消息失败
  export const CODE_507 = 507; // 507: 1:1 通话对方忙
  export const CODE_508 = 508; // 508: 多人通话对方所有人忙
  export const CODE_509 = 509; // 509: 会议已结束
  export const CODE_510 = 510; // 510:密码错误
  export const CODE_511 = 511; // 511:已在当前房间内通话
  export const CODE_512 = 512; // 其他人在共享屏幕
  export const CODE_701 = 701; // 701:参数解析异常
  export const CODE_702 = 702; // 702:主叫人userId不能为空
  export const CODE_703 = 703; // 703:参与人UserId不能为空
  export const CODE_601 = 601; // 601:license到期或过期
  export const CODE_513 = 513; // 513: 当前参会人数已达许可上线

  export type Code =
    | typeof SUCCESS_CODE
    | typeof CODE_0
    | typeof CODE_201
    | typeof CODE_401
    | typeof CODE_444
    | typeof CODE_445
    | typeof CODE_500
    | typeof CODE_501
    | typeof CODE_502
    | typeof CODE_503
    | typeof CODE_504
    | typeof CODE_505
    | typeof CODE_506
    | typeof CODE_507
    | typeof CODE_508
    | typeof CODE_509
    | typeof CODE_510
    | typeof CODE_511
    | typeof CODE_512
    | typeof CODE_701
    | typeof CODE_702
    | typeof CODE_703
    | typeof CODE_601
    | typeof CODE_513;
  export type Result<T = any> = {
    code: Code;
    data: T;
    msg: string;
  };
}
